import React, { Component, Fragment } from 'react'

import helpers from '../../helpers'

import Button from '../../components/Button/'
import Select from '../../components/Select/'
import Input from '../../components/Input/'
import Password from '../../components/Input/Password'
import Textarea from '../../components/Input/Textarea'
import Upload from '../../components/Upload/'
import CheckBox from '../../components/CheckBox/'
import PasswordIndicator from '../../components/PasswordIndicator/'
import { GirlColor, BoyColor } from '../../components/Icons'

import {
  StyledForm,
  ButtonContainer,
  IconContainer,
  Inner,
  Feedback,
  Footer,
  Title,
  PasswordFeedback,
  InputFeedback
} from './styles'
import { white, red, almostblack, lightgray } from '../../styles/colors'

class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: props.fields || [],
      saved: false,
      submitted: this.props.submitted ? this.props.submitted : false,
      passwordStrength: {
        minimal: '',
        strength: 0
      }
    }
  }

  componentDidMount() {
    if (!this.props.error) {
      this.setState({ submitted: false })
    }
    // const { fields } = this.state
    // fields.map(field => {
    //   if (field.type === 'select') {
    //     field.value = field.options[0].value
    //   }
    //   return null
    // })
    // this.setState({ fields })
  }

  handleChange(e) {
    const { fields } = this.state
    const key = e.target.dataset.key

    if (fields[key].type === 'checkbox') {
      fields[key].value = !fields[key].value
    } else if (fields[key].type === 'password' && fields[key].name === 'newPassword') {
      fields[key].value = e.target.value
      this.setState({
        password: e.target.value,
        passwordStrength: helpers.calculatePasswordStrenght(e.target.value)
      })
    } else {
      fields[key].value = e.target.value
    }

    this.setState({ fields: fields })
  }

  handleSubmit(e) {
    e.preventDefault()
    this.setState({ saved: true, submitted: true })
    const data = {}

    if (this.props.branches) {
      data.branches = []
    }

    this.state.fields.map(field => {
      if (field.type === 'checkbox' && field.value && !this.props.permissions) {
        data.branches.push(field.name)
        return null
      } else {
        if (field.type !== 'checkbox' || this.props.permissions) {
          data[field.name] = field.value !== '' ? field.value : null
        }
        return null
      }
    })

    if (this.props.userId && this.props.userId !== '') {
      data.id = this.props.userId
    }

    try {
      this.props.onSubmitForm({ variables: { data } })
    } catch (e) {
      console.error(e)
    }
  }

  render() {
    const { submitText, userImage, passwordStrength } = this.props
    return (
      <StyledForm
        onSubmit={e => {
          if (passwordStrength) {
            if (this.state.passwordStrength.minimal) {
              this.handleSubmit.bind(this)
            } else {
              e.preventDefault()
            }
          } else {
            this.handleSubmit.bind(this)
          }
        }}
      >
        {userImage ? (
          <IconContainer>{this.props.gender === 'FEMALE' ? <GirlColor size='' /> : <BoyColor size='' />}</IconContainer>
        ) : null}

        <Inner>
          {this.state.fields.map((field, index) => {
            if (field.type === 'select') {
              return (
                <Select
                  key={index}
                  dataKey={index}
                  value={field.value}
                  handleChange={this.handleChange.bind(this)}
                  name={field.name}
                  label={field.label}
                  options={field.options}
                />
              )
            } else if (field.type === 'checkbox') {
              return (
                <CheckBox
                  key={index}
                  dataKey={index}
                  value={field.value}
                  handleChange={this.handleChange.bind(this)}
                  name={field.name}
                >
                  {field.label}
                </CheckBox>
              )
            } else if (field.type === 'password') {
              return (
                <Password
                  key={index}
                  dataKey={index}
                  value={field.value}
                  handleChange={this.handleChange.bind(this)}
                  name={field.name}
                  label={field.label}
                />
              )
            } else if (field.type === 'textarea') {
              return (
                <Fragment key={index}>
                  <Textarea
                    key={index}
                    dataKey={index}
                    value={field.value}
                    handleChange={this.handleChange.bind(this)}
                    name={field.name}
                    label={field.label}
                    valid={this.state.submitted && field.required === 'required' ? field.value !== '' : true}
                  />
                  {this.state.submitted && field.required === 'required' ? (
                    <Fragment>
                      {field.value === '' ? <InputFeedback>Vul uw {field.label.toLowerCase()} in</InputFeedback> : null}
                    </Fragment>
                  ) : null}
                </Fragment>
              )
            } else if (field.type === 'file') {
              return (
                <Upload
                  key={index}
                  dataKey={index}
                  value={field.value}
                  handleChange={this.handleChange.bind(this)}
                  name={field.name}
                  label={field.label}
                />
              )
            } else if (field.type === 'title') {
              return <Title key={index}>{field.name}</Title>
            } else {
              return (
                <Fragment key={index}>
                  <Input
                    key={index}
                    dataKey={index}
                    value={field.value}
                    handleChange={this.handleChange.bind(this)}
                    name={field.name}
                    type={field.type}
                    label={field.label}
                    valid={this.state.submitted && field.required === 'required' ? field.value !== '' : true}
                  />
                  {this.state.submitted && field.required === 'required' ? (
                    <Fragment>
                      {field.value === '' ? <InputFeedback>Vul uw {field.label.toLowerCase()} in</InputFeedback> : null}
                    </Fragment>
                  ) : null}
                </Fragment>
              )
            }
          })}

          {passwordStrength ? (
            <Fragment>
              {this.state.passwordStrength.minimal ? (
                <PasswordIndicator passwordStrength={this.state.passwordStrength} />
              ) : this.state.passwordStrength.minimal === false ? (
                <PasswordFeedback>Nog minimaal {10 - this.state.password.length} tekens toevoegen.</PasswordFeedback>
              ) : null}
            </Fragment>
          ) : null}

          <Footer>
            <ButtonContainer>
              {passwordStrength ? (
                <Button
                  background={this.state.passwordStrength.minimal ? red : lightgray}
                  color={white}
                  radius='true'
                  hover={this.state.passwordStrength.minimal ? almostblack : lightgray}
                  onSubmit={this.state.passwordStrength.minimal ? this.handleSubmit.bind(this) : null}
                >
                  {submitText}
                </Button>
              ) : (
                <Button
                  background={red}
                  color={white}
                  radius='true'
                  hover={almostblack}
                  onSubmit={this.handleSubmit.bind(this)}
                >
                  {submitText}
                </Button>
              )}
            </ButtonContainer>
            <Feedback saved={this.state.saved}>
              {this.props.loading && <span>Laden...</span>}
              {this.props.error && <span>Formulier bevat fouten</span>}
              {this.props.data && (
                <span>{this.props.succesMessage ? this.props.succesMessage : 'Uw wijzigingen zijn opgeslagen'}</span>
              )}
            </Feedback>
          </Footer>
        </Inner>
      </StyledForm>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/components/Form/index.js